import ImageGallery from './ImageGallery';

export default ImageGallery;
